import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import DynamicFormScreen from '../index';
import Button from '../../Common/Button';
import ConfigService from "../../../Services/api/Config";
import Icon from "../../Common/Icon";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";
import InputSelect from '../../FormFields/Select';

class ModalPreviewForm extends React.PureComponent {

  state = {
    previewLanguage: (this.props.availableLanguages && this.props.availableLanguages.length > 0) ? this.props.configuration.created_in_language : null,
  };

  onPressClose = (event) => this.props.onClose(event);

  render() {
    const { configuration, availableLanguages} = this.props;
    configuration.disabled = true;
    configuration.preview = true;
    configuration.fields.map((section) => {
      section.disabled = true;
      section.previewLanguage = this.state.previewLanguage;
      section.children.map((field) => {
        field.disabled = true;
        field.previewLanguage = this.state.previewLanguage;
      });
    });
    const data = {
      df: configuration,
      print: true,
      isFormBuilder: true,
      previewLanguage: this.state.previewLanguage
    };
    const config = {
      config: {
        url_config: ConfigService.urlConfig,
        theme_config: ConfigService.themeConfig,
      }
    };
    return (
      <Modal
        isOpen
        onRequestClose={ this.onPressClose }
        contentLabel='Preview Form'
        className='Modal_Content Modal_Content_Dynamic'
        overlayClassName='Modal_Overlay'
      >
        <div className='Modal_Content_Container Modal_Content_Container_Dynamic'>
        {!(availableLanguages && availableLanguages.length > 0) && <h2>Preview Form { configuration.label }</h2>}
          {availableLanguages && availableLanguages.length > 0 && this.props.configuration.created_in_language && <div className='previewFormHeader'>
            <div className='previewFormHeader_child'>
              <h2 className='previewFormHeader_header'>Preview Form {configuration.label}</h2>
              <InputSelect label='Select Language' options={availableLanguages} value={this.state.previewLanguage}
                onChange={v => this.setState({ previewLanguage: v })} className='previewFormHeader_select'/>
            </div>
          </div>}
          <DynamicFormScreen data={ data } configTheme={ config } availableLanguages = {availableLanguages}/>
          <div className='Modal_Content_Actions Center'>
            <Button className='Inline'
              onClick={ this.onPressClose }
            >Ok
            </Button>
          </div>
          <div className='Modal_Content_Close' onClick={ this.onPressClose }>
            <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
              <CloseIcon alt='icon-close'/>
            </Icon>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalPreviewForm.propTypes = {
  configuration: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalPreviewForm;
